import React from 'react';

import MapWrapper from '../components/MapWrapper';
import { useAffiliation } from '../hooks/useAffiliation';
import { useStations } from '../hooks/useStations';
import { strings } from '../strings';
import { usePageMeta } from '../utils/pageMeta';

const MapScreen = () => {
  const { stations } = useStations();
  const { affiliation } = useAffiliation();
  usePageMeta(strings.pageMeta.map);

  return <MapWrapper stations={stations} affiliation={affiliation} />;
};

export default MapScreen;
